import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Boxes, KeyRound, Activity, LogOut, ArrowUpRight, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAdmin } from "@/context/AdminContext";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Overview", testid: "nav-overview" },
  { to: "/admin/users", icon: Users, label: "Users", testid: "nav-users" },
  { to: "/admin/apps", icon: Boxes, label: "Connected Apps", testid: "nav-apps" },
  { to: "/admin/entra", icon: KeyRound, label: "Entra Config", testid: "nav-entra" },
  { to: "/admin/email", icon: Mail, label: "Email Settings", testid: "nav-email" },
  { to: "/admin/audit", icon: Activity, label: "Audit Log", testid: "nav-audit" },
];

export default function AdminLayout() {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  if (!admin) return null;

  return (
    <div className="min-h-screen flex bg-zinc-950 text-zinc-100">
      <aside className="w-60 border-r border-zinc-800/80 flex flex-col py-6 px-3">
        <div className="px-3 mb-8">
          <Logo />
          <div className="mt-1 text-[10px] font-mono text-amber-400/80 uppercase tracking-widest">/ admin</div>
        </div>
        <nav className="space-y-1 flex-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive ? "bg-zinc-800 text-zinc-50" : "text-zinc-400 hover:bg-zinc-900 hover:text-zinc-100"
                }`
              }
            >
              <l.icon className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-1 px-1">
          <div className="px-3 py-2 text-xs text-zinc-500 font-mono truncate" title={admin.email}>{admin.email}</div>
          <Button variant="ghost" size="sm" className="w-full justify-start text-zinc-400 hover:text-zinc-100" onClick={handleLogout} data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Sign out
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
